import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";

@Component({
  selector: 'app-change-pin',
  templateUrl: './change-pin.component.html',
  standalone:false,
  styleUrls: ['./change-pin.component.scss']
})
export class ChangePinComponent implements OnInit {

  constructor(private router:Router, private location: Location) { }
  
  back() {
    this.location.back()
  }

  ngOnInit(): void {
  }

}
